module.exports = __webpack_public_path__ + "static/media/juegos-1.6d6ad32c.jpg";